/* E.N.D. CRUISE KIT - shared behavior. Safe to load more than once.
   Re-runs automatically when the theme editor adds, moves or edits a section. */
(function () {
  if (window.__endCruise) return;
  window.__endCruise = true;

  var CFG = function () { return window.END_CFG || {}; };
  var main = function () { return document.getElementById('MainContent') || document.body; };
  var timers = [];
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---- booking links ---- */
  function cleanLinks() {
    var c = CFG(); if (!c.book) return;
    document.querySelectorAll('[data-end-book]').forEach(function (a) { a.href = c.book; });
    if (!c.clean) return;
    main().querySelectorAll('a[href*="sixthman.net/pioneer/booking"]').forEach(function (a) { a.href = c.book; });
    main().querySelectorAll('a').forEach(function (a) {
      var txt = (a.textContent || '').trim();
      if (/^book now$/i.test(txt) && /endcruise\.com/.test(a.href)) a.href = c.book;
      if (/^https?:\/\//i.test(txt)) a.style.display = 'none';
    });
  }

  /* ---- countdowns (any number, each with its own date or the page default) ---- */
  function countdowns() {
    timers.forEach(clearTimeout); timers = [];
    var c = CFG();
    var clocks = document.querySelectorAll('[data-end-count]');
    var days = document.querySelectorAll('[data-end-days]');
    var target = function (el) { return new Date((el && el.dataset.sail) || c.sail || '').getTime(); };
    function tick() {
      var now = Date.now();
      clocks.forEach(function (el) {
        var diff = target(el) - now; if (isNaN(diff)) return;
        if (diff <= 0) { el.innerHTML = '<span class="end-count__n"></span>'; el.firstChild.textContent = el.dataset.atSea || c.atSea || 'We are at sea'; return; }
        var u = { d: Math.floor(diff / 864e5), h: Math.floor(diff / 36e5) % 24, m: Math.floor(diff / 6e4) % 60, s: Math.floor(diff / 1e3) % 60 };
        ['d','h','m','s'].forEach(function (k) { var n = el.querySelector('[data-u="' + k + '"]'); if (n) n.textContent = k === 'd' ? u.d : pad(u[k]); });
      });
      days.forEach(function (el) {
        var diff = target(el) - now; if (isNaN(diff)) return;
        el.textContent = Math.max(0, Math.floor(diff / 864e5));
      });
      timers.push(setTimeout(tick, 1000));
    }
    if (clocks.length || days.length) tick();
  }

  /* ---- tickers ---- */
  function tickers() {
    document.querySelectorAll('[data-end-marquee]').forEach(function (track) {
      if (track.dataset.built === '1') return;
      var sep = track.dataset.sep || '';
      var items = Array.prototype.slice.call(track.children);
      track.innerHTML = '';
      for (var r = 0; r < 2; r++) items.forEach(function (el, i) {
        track.appendChild(el.cloneNode(true));
        if (sep) { var img = document.createElement('img'); img.className = 'end-marquee__sep'; img.alt = ''; img.src = sep; track.appendChild(img); }
      });
      track.dataset.built = '1';
    });
  }

  /* ---- background artwork alignment + starfish ---- */
  /* ---- keep floating critters clear of photos and text (nudges them up/down, never covers content) ---- */
  function obstacles(M, skip) {
    var out = [];
    M.querySelectorAll('img:not(.end-stars img):not(.end-art), video, iframe, h1, h2, h3, h4, p, a, button, .card, .end-pass, .end-band, .end-tabs__bar')
      .forEach(function (el) { if (skip && skip(el)) return; var r = el.getBoundingClientRect(); if (r.width && r.height) out.push([r.left + scrollX, r.top + scrollY, r.right + scrollX, r.bottom + scrollY]); });
    return out;
  }
  function placeCritters() {
    var M = main(); if (!M) return;
    var arts = M.querySelectorAll('.end-art--float[data-clear]'); if (!arts.length) return;
    /* phones only: on wider screens the critters keep exactly the spot they were given */
    if (window.innerWidth >= 750) { arts.forEach(function (el) { el.style.marginTop = ''; el.style.width = ''; }); return; }
    var boxes = obstacles(M, function (el) { return el.closest('.end-marquee'); }), gap = 14;
    arts.forEach(function (el) {
      el.style.marginTop = '0px'; el.style.width = '';
      var p = el.offsetParent; if (!p) return;
      var pr = p.getBoundingClientRect(), cs = getComputedStyle(el);
      var mdx = cs.getPropertyValue('--m-dx').trim(), mdy = cs.getPropertyValue('--m-dy').trim();
      var dx = parseFloat(mdx || cs.getPropertyValue('--dx')) || 0, dy = parseFloat(mdy || cs.getPropertyValue('--dy')) || 0;
      var x = pr.left + scrollX + el.offsetLeft + dx, y0 = pr.top + scrollY + el.offsetTop + dy, w0 = el.offsetWidth, h0 = el.offsetHeight;
      var right = el.style.getPropertyValue('--right') !== '' || cs.getPropertyValue('--right').trim() !== '';
      function hit(xx, y, w, h) { for (var k = 0; k < boxes.length; k++) { var q = boxes[k]; if (xx < q[2] + gap && xx + w > q[0] - gap && y < q[3] + gap && y + h > q[1] - gap) return true; } return false; }
      var best = null;
      [1, .85, .7, .55].some(function (f) {                  /* try full size first, then gently smaller */
        var w = w0 * f, h = h0 * f, xx = right ? x + (w0 - w) : x;
        for (var step = 0; step <= 16; step++) {
          var n = step === 0 ? 0 : (step % 2 ? -1 : 1) * Math.ceil(step / 2) * 20;
          if (!hit(xx, y0 + n, w, h)) { best = { f: f, n: n, x: xx, w: w, h: h }; return true; }
        }
        return false;
      });
      if (!best) return;
      if (best.f < 1) el.style.width = Math.round(best.w) + 'px';
      el.style.marginTop = best.n + 'px';
      boxes.push([best.x, y0 + best.n, best.x + best.w, y0 + best.n + best.h]);
    });
  }

  /* phones + tablets: starfish drift behind the content (they only show in the gaps between sections) */
  function phoneStars(eng, M, layer) {
    var stars = (eng.dataset.mStars || '').split('|').filter(Boolean);
    if (!stars.length) { if (layer) layer.remove(); return; }
    if (!layer) { layer = document.createElement('div'); layer.setAttribute('aria-hidden', 'true'); M.insertBefore(layer, M.firstChild); }
    layer.className = 'end-stars end-stars--m';
    var W = M.clientWidth, H = M.scrollHeight, spacing = +eng.dataset.mStarSpacing || 600, base = +eng.dataset.mStarSize || 50,
        op = eng.dataset.mStarOpacity || '.6', heroEl = document.querySelector('[data-end-hero]'),
        top0 = heroEl ? heroEl.getBoundingClientRect().bottom - M.getBoundingClientRect().top : 300,
        count = Math.max(2, Math.round((H - top0) / spacing)), rand = rng(2027), html = '', band = (H - top0 - 100) / count;
    var mr = M.getBoundingClientRect(), ox = mr.left + scrollX, oy = mr.top + scrollY,
        boxes = obstacles(M).map(function (b) { return [b[0] - ox, b[1] - oy, b[2] - ox, b[3] - oy]; });
    function hitBox(x, y, w) { for (var k = 0; k < boxes.length; k++) { var q = boxes[k]; if (x < q[2] + 12 && x + w > q[0] - 12 && y < q[3] + 14 && y + w > q[1] - 14) return true; } return false; }
    for (var i = 0; i < count; i++) {
      var size0 = base * (0.7 + rand() * 0.6), left = i % 2 === 0, x, y, size = size0, tries = 0, ok = false;
      for (; tries < 80 && !ok; tries++) {             /* only in an empty gap (it also sits behind the content) */
        size = tries < 40 ? size0 : size0 * 0.7;
        var edge = tries % 4 !== 3;                    /* mostly hug the edges, sometimes anywhere across */
        x = edge ? (left ? rand() * (W * 0.3) : W * 0.7 + rand() * (W * 0.3 - size)) : rand() * (W - size);
        y = top0 + band * i + rand() * band;
        ok = !hitBox(x, y, size);
      }
      if (!ok) continue;                               /* no clear gap nearby: skip it rather than sit behind text */
      boxes.push([x - 30, y - 30, x + size + 30, y + size + 30]);
      var rot = Math.round(-180 + rand() * 360), spin = Math.round((rand() < .5 ? -1 : 1) * (20 + rand() * 40)),
          dx = Math.round((rand() < .5 ? -1 : 1) * (4 + rand() * 8)), dur = (10 + rand() * 8).toFixed(1), del = (-rand() * 12).toFixed(1),
          flip = rand() < .5 ? -1 : 1;
      html += '<span style="left:' + Math.round(Math.max(0, x)) + 'px;top:' + Math.round(y) + 'px;width:' + Math.round(size) + 'px;height:' + Math.round(size) + 'px;opacity:' + op +
              ';--rot:' + rot + 'deg;--spin:' + spin + 'deg;--dx:' + dx + 'px;--flip:' + flip + ';animation-duration:' + dur + 's;animation-delay:' + del + 's"><img src="' + stars[i % stars.length] + '" alt="" loading="lazy"></span>';
    }
    layer.innerHTML = html;
  }

  /* ---- "scattered" starfish layout (Engine > Starfish layout). Off unless picked in the editor. ----
     Stars are spread with best-candidate sampling (each new star takes the open spot furthest from the others),
     mixed sizes and angles, and they never sit on content or on a critter's resting spot. */
  function critterBox(el) {
    /* where the critter rests, ignoring its swim-in/bob offset */
    var r = el.getBoundingClientRect(), t = (getComputedStyle(el).translate || '').split(' ');
    var tx = parseFloat(t[0]) || 0, ty = parseFloat(t[1]) || 0;
    return [r.left - tx, r.top - ty, r.right - tx, r.bottom - ty];
  }
  function scatterStars(eng, M, layer, phone) {
    placeCritters();
    var stars = ((phone ? eng.dataset.mStars : eng.dataset.stars) || '').split('|').filter(Boolean);
    if (!stars.length) { if (layer) layer.remove(); return; }
    if (!layer) { layer = document.createElement('div'); layer.setAttribute('aria-hidden', 'true'); M.insertBefore(layer, M.firstChild); }
    layer.className = phone ? 'end-stars end-stars--m' : 'end-stars';
    layer.innerHTML = '';
    var mr = M.getBoundingClientRect(), W = M.clientWidth, H = M.scrollHeight, boxes = [];
    var pad = phone ? 12 : 18, cpad = phone ? 18 : 30;
    M.querySelectorAll('img:not(.end-stars img), video, iframe, svg, picture, h1, h2, h3, h4, p, a, button, li, .card, .end-pass, .end-band, .end-marquee, .end-tabs__bar, .media, .end-art')
      .forEach(function (el) {
        var isArt = el.classList.contains('end-art'), b;
        if (isArt) { b = critterBox(el); if (b[2] - b[0] < 1) return; }
        else { var r = el.getBoundingClientRect(); if (!r.width || !r.height) return; b = [r.left, r.top, r.right, r.bottom]; }
        var p = isArt ? cpad : pad;
        boxes.push([b[0] - mr.left - p, b[1] - mr.top - p, b[2] - mr.left + p, b[3] - mr.top + p]);
      });
    function free(x, y, sz) { for (var k = 0; k < boxes.length; k++) { var q = boxes[k]; if (x < q[2] && x + sz > q[0] && y < q[3] && y + sz > q[1]) return false; } return true; }
    var heroEl = document.querySelector('[data-end-hero]');
    var top0 = heroEl ? heroEl.getBoundingClientRect().bottom - mr.top + 20 : 300, bottom = H - 60;
    var spacing = +(phone ? eng.dataset.mStarSpacing : eng.dataset.starSpacing) || (phone ? 600 : 900);
    var base = phone ? (+eng.dataset.mStarSize || 50) : 80;
    var op = +(phone ? eng.dataset.mStarOpacity : eng.dataset.starOpacity) || (phone ? .6 : .9);
    var count = Math.max(3, Math.round((bottom - top0) / spacing * (phone ? 1 : 1.3))), rand = rng(phone ? 2627 : 1926);
    var placed = [], html = '';
    for (var i = 0; i < count; i++) {
      /* sizes: mostly medium, some small, the odd big one */
      var roll = rand(), f = roll < .2 ? .55 + rand() * .2 : roll > .9 ? 1.35 + rand() * .3 : .8 + rand() * .4;
      var size = Math.round(base * f), best = null, bestD = -1;
      for (var c = 0; c < 40; c++) {
        var x, edge = rand() < (phone ? .55 : .7);            /* lean toward the sides, but not a strict column */
        if (edge) { var side = rand() < .5, span = W * (phone ? .28 : .16); x = side ? rand() * span - size * .15 : W - span + rand() * span - size * .85; }
        else x = rand() * (W - size);
        x = Math.max(-size * .2, Math.min(W - size * .8, x));
        var y = top0 + rand() * Math.max(1, bottom - top0 - size);
        if (!free(x, y, size)) continue;
        var d = 1e9;
        for (var j = 0; j < placed.length; j++) { var dx = placed[j][0] - x, dy = (placed[j][1] - y) * 1.15; d = Math.min(d, Math.sqrt(dx * dx + dy * dy) - placed[j][2] * .5); }
        if (d > bestD) { bestD = d; best = [x, y]; }
      }
      if (!best) continue;
      placed.push([best[0], best[1], size]);
      boxes.push([best[0] - 20, best[1] - 30, best[0] + size + 20, best[1] + size + 30]);
      var rot = Math.round(-180 + rand() * 360), spin = Math.round((rand() < .5 ? -1 : 1) * (15 + rand() * 45)),
          ddx = Math.round((rand() < .5 ? -1 : 1) * (4 + rand() * (phone ? 8 : 14))), dur = (9 + rand() * 9).toFixed(1), del = (-rand() * 12).toFixed(1),
          flip = rand() < .5 ? -1 : 1, o = (op * (.75 + rand() * .25)).toFixed(2);
      html += '<span style="left:' + Math.round(best[0]) + 'px;top:' + Math.round(best[1]) + 'px;width:' + size + 'px;height:' + size + 'px;opacity:' + o +
              ';--rot:' + rot + 'deg;--spin:' + spin + 'deg;--dx:' + ddx + 'px;--flip:' + flip + ';animation-duration:' + dur + 's;animation-delay:' + del + 's"><img src="' + stars[(i + Math.floor(rand() * 2)) % stars.length] + '" alt="" loading="lazy"></span>';
    }
    layer.innerHTML = html;
  }

  function backdrop() {
    var eng = document.querySelector('[data-end-engine]'); if (!eng) return;
    var M = main(), hero = document.querySelector('[data-end-hero]');
    M.style.setProperty('--end-w', M.clientWidth + 'px');
    M.style.setProperty('--end-hero-top', hero ? Math.round(hero.getBoundingClientRect().top - M.getBoundingClientRect().top) + 'px' : '0px');

    var stars = (eng.dataset.stars || '').split('|').filter(Boolean);
    var layer = M.querySelector('.end-stars');
    if (eng.dataset.starLayout === 'scatter') { scatterStars(eng, M, layer, window.innerWidth < 1200); return; }
    if (window.innerWidth < 1200) { phoneStars(eng, M, layer); return; }
    if (!stars.length) { if (layer) layer.remove(); return; }
    if (layer) layer.classList.remove('end-stars--m');
    if (!layer) { layer = document.createElement('div'); layer.className = 'end-stars'; layer.setAttribute('aria-hidden', 'true'); M.insertBefore(layer, M.firstChild); }
    layer.innerHTML = '';

    /* everything a starfish must never sit on: photos, video, text, buttons, cards, critters */
    var mr = M.getBoundingClientRect(), W = M.clientWidth, H = M.scrollHeight, pad = 18, boxes = [];
    M.querySelectorAll('img:not(.end-stars img), video, iframe, svg, picture, h1, h2, h3, h4, p, a, button, li, .card, .end-pass, .end-band, .end-marquee, .end-tabs__bar, .media, .end-art')
      .forEach(function (el) {
        var r = el.getBoundingClientRect(); if (!r.width || !r.height) return;
        var ex = el.classList.contains('end-art') ? 240 : 0, ey = ex ? 100 : 0;   /* critters may still be mid swim-in */
        boxes.push([r.left - mr.left - pad - ex, r.top - mr.top - pad - ey, r.right - mr.left + pad + ex, r.bottom - mr.top + pad + ey]);
      });
    function clear(x, y, sz) { for (var k = 0; k < boxes.length; k++) { var q = boxes[k]; if (x < q[2] && x + sz > q[0] && y < q[3] && y + sz > q[1]) return false; } return true; }

    var spacing = +eng.dataset.starSpacing || 900, op = eng.dataset.starOpacity || '.9';
    var heroEl = document.querySelector('[data-end-hero]'), top0 = heroEl ? heroEl.getBoundingClientRect().bottom - mr.top + 40 : 400;
    var count = Math.max(3, Math.round((H - top0) / spacing)), rand = rng(1980), html = '', placed = 0;
    for (var i = 0; i < count; i++) {
      var size = 54 + rand() * 70, band = (H - top0 - 200) / count, ok = false, x = 0, y = 0;
      for (var t = 0; t < 14 && !ok; t++) {                     /* try spots in this slice of the page, both sides */
        var left = (i + t) % 2 === 0;
        x = left ? 8 + rand() * 60 : W - size - 8 - rand() * 60;
        y = top0 + band * i + rand() * band;
        ok = clear(x, y, size);
      }
      if (!ok) continue;
      boxes.push([x - 40, y - 60, x + size + 40, y + size + 60]);  /* keep stars apart, leave room to drift */
      var rot = Math.round(-180 + rand() * 360), spin = Math.round((rand() < .5 ? -1 : 1) * (25 + rand() * 60)),
          dx = Math.round((rand() < .5 ? -1 : 1) * (6 + rand() * 16)), dur = (9 + rand() * 8).toFixed(1), del = (-rand() * 12).toFixed(1),
          flip = rand() < .5 ? -1 : 1, src = stars[placed % stars.length];
      html += '<span style="left:' + Math.round(x) + 'px;top:' + Math.round(y) + 'px;width:' + Math.round(size) + 'px;height:' + Math.round(size) + 'px;opacity:' + op +
              ';--rot:' + rot + 'deg;--spin:' + spin + 'deg;--dx:' + dx + 'px;--flip:' + flip + ';animation-duration:' + dur + 's;animation-delay:' + del + 's"><img src="' + src + '" alt="" loading="lazy"></span>';
      placed++;
    }
    layer.innerHTML = html;
  }

  /* ---- auto-styling of the theme's own sections ---- */
  function autoStyle() {
    var eng = document.querySelector('[data-end-engine]'); if (!eng) return;
    var key = (eng.dataset.recapKeyword || '').toLowerCase();
    var flip = 0, inRecap = false;
    main().querySelectorAll('.shopify-section').forEach(function (sec) {
      sec.classList.remove('end-auto-activity', 'end-auto-recap', 'end-tilt-right');
      if (sec.querySelector('[data-end-section]')) return;
      var h = sec.querySelector('h2'), heading = h ? h.textContent.trim().toLowerCase() : '';
      if (!inRecap && key && heading.indexOf(key) > -1) inRecap = true;
      if (inRecap) { sec.classList.add('end-auto-recap'); return; }
      if (/image_with_text/.test(sec.id || '')) { sec.classList.add('end-auto-activity'); if (flip++ % 2) sec.classList.add('end-tilt-right'); }
    });
  }

  /* ---- sticky booking bar ---- */
  function sticky() {
    document.querySelectorAll('[data-end-sticky]').forEach(function (bar) {
      if (bar.dataset.built === '1') return;
      bar.dataset.built = '1';
      /* On the live page, lift the bar out of the page content and attach it straight to the page body.
         iPhone Safari keeps a fixed bar glued to the screen more reliably when it isn't nested inside the
         big patterned content area. (Left in place inside the theme editor so the section stays selectable.) */
      if (!(window.Shopify && Shopify.designMode)) { bar.classList.add('end-sticky--lifted'); document.body.appendChild(bar); }
      var after = +bar.dataset.after || 600;
      var footer = document.querySelector('footer, .footer, [id*="footer"]');
      var hideAt = document.querySelector('[data-end-reef]');
      var onScroll = function () {
        var past = window.scrollY > after, near = false;
        [footer, hideAt].forEach(function (el) {
          if (!el) return; var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) near = true;
        });
        bar.classList.toggle('is-on', past && !near);
      };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    });
  }

  /* ---- critters: swim in each time their spot scrolls into view, exit when scrolled past ----
     Visibility is judged from where the critter will land, not where it waits, so a critter
     parked off the side of the screen for its swim-in still gets triggered. */
  var exitBound = false, enterBound = false;
  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function landing(el) {
    var p = el.offsetParent; if (!p) return null;
    var dy = parseFloat(getComputedStyle(el).getPropertyValue('--dy')) || 0;
    var top = p.getBoundingClientRect().top + el.offsetTop + dy;
    return { top: top, bottom: top + el.offsetHeight };
  }
  function checkEnter() {
    var vh = window.innerHeight;
    document.querySelectorAll('.end-art[data-enter]').forEach(function (el) {
      if (el.classList.contains('is-out')) return;
      var r = landing(el); if (!r) return;
      if (r.top < vh * 0.9 && r.bottom > vh * 0.05) el.classList.add('is-in');
      else if (r.top > vh || r.bottom < 0) el.classList.remove('is-in');
    });
  }
  function critters() {
    document.documentElement.classList.add('end-js');
    if (reduced()) { document.querySelectorAll('.end-art[data-enter]').forEach(function (el) { el.classList.add('is-in'); }); return; }
    checkEnter();
    if (!enterBound) {
      enterBound = true; var t = false;
      var go = function () { if (!t) { t = true; requestAnimationFrame(function () { t = false; checkEnter(); }); } };
      window.addEventListener('scroll', go, { passive: true }); window.addEventListener('resize', go); window.addEventListener('load', go);
    }
    if (!exitBound) { exitBound = true; bindExits(); }
  }
  function bindExits() {
    var lastY = window.scrollY, ticking = false;
    function check() {
      ticking = false;
      var y = window.scrollY, down = y > lastY, vh = window.innerHeight; lastY = y;
      document.querySelectorAll('.end-art[data-exit]').forEach(function (el) {
        var line = (+el.dataset.exitAt || 25) / 100 * vh, r = el.getBoundingClientRect(), mid = r.top + r.height / 2;
        var entered = !el.hasAttribute('data-enter') || el.classList.contains('is-in');
        if (down && entered && mid < line && mid > -r.height && !el.classList.contains('is-out')) el.classList.add('is-out');
        else if (!down && mid > line && el.classList.contains('is-out')) {
          el.classList.remove('is-out', 'is-in'); void el.offsetWidth;          /* restart the swim-in */
          requestAnimationFrame(function () { el.classList.add('is-in'); });
        }
      });
    }
    window.addEventListener('scroll', function () { if (!ticking && !reduced()) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
  }

  function init() { cleanLinks(); tickers(); autoStyle(); backdrop(); countdowns(); sticky(); critters(); placeCritters(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', function () { backdrop(); placeCritters(); setTimeout(function () { backdrop(); placeCritters(); }, 1500); });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { backdrop(); placeCritters(); }, 150); });
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(init, 50); });
  });
})();
